<template>
    <nav class="tabs" :class="wrapperClass">
        <button
            class="tabs__item"
            type="button"
            v-for="tab in tabs"
            :ref="tab.value"
            :key="tab.title"
            :class="[{ 'tabs__item_active' : tab.value === currentTab }, tab.value === currentTab && tabActiveClass ? tabActiveClass: '', tabClass, ]"
            :disabled="tab.disabled || false"
            @click="handleClick(tab.value)"
            v-html="tab.title"></button>

        <div
            class="tabs__active-line"
            :class="lineClass"></div>
    </nav>
</template>

<script>
	export default {
		name: 'Tabs',
		data() {
            return {
                activeLineWidth: 0,
                activeLineOffset: 0,
                newTab: '',
            };
        },
        props: {
            currentTab: { 
                type: String, 
                required: true
            },
            tabs: { 
                type: Array, 
                required: true 
            },
            updated: { 
                type: [Boolean, String, Array], 
                default: undefined 
            },
            wrapperClass: { 
                type: String, 
                required: false 
            },
            tabClass: { 
                type: String, 
                required: false,
            },
            tabActiveClass: {
                type: String,
                required: false,
            },
            lineClass: {
                type: String,
                required: false,
            },
        },
        methods: {
            handleClick(value) 
            {
                this.$emit('on-click', value);
                this.moveActiveLine(value);

                this.newTab = value;
            },
            moveActiveLine(newValue) 
            {
                if (!this.currentTab) return;

                if (!this.$refs || !this.$refs[newValue] || !this.$refs[newValue][0]) return;
                const element = this.$refs[newValue][0];

                this.activeLineWidth = element.clientWidth;
                this.activeLineOffset = element.offsetLeft;
            },
        },
        watch: {
            currentTab(newCurrentTab) 
            {
                if (this.newTab === newCurrentTab) return;
                this.moveActiveLine(newCurrentTab);
                this.newTab = newCurrentTab;
            },
            updated() 
            {
                this.moveActiveLine(this.currentTab);
            },
        },
        mounted: function () 
        {
            this.moveActiveLine(this.currentTab);
            this.newTab = this.currentTab;
        },
	}
</script>